import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { MotorsDraftFacade, RouterFacade } from '@classifieds-sell/state';
import { StepIds } from 'libs/motors-ui/src/lib/models/motors-step/motors-step-model';
import { MotorsPageBase } from '../../../motors-page-base';

@Component({
    templateUrl: './motors-summary-page.component.html',
    styleUrls: ['./motors-summary-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BoatsAndMarineSummaryPageComponent
    extends MotorsPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    constructor(draftFacade: MotorsDraftFacade, routerFacade: RouterFacade) {
        super(StepIds.summary, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngAfterViewInit() {
        // TODO: do something like super.registerSection();
    }
}
